import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    general: {
      // true, sobald das Backend über /api antwortet (Ping in App.vue).
      // Ersetzt den früheren Login als Zugriffs-Gate — nginx beschränkt /api/
      // aufs Heimnetz, von außen kommt 403.
      localNetwork: false,
    },
    smarthaus: {
      data: [],
      rooms: [],
      devices: [],
      routines: [],
      types: [],
      debug: "ABC",
      finanzen: {
        shares: [],
        sales: [],
        dividends: [],
        summary: null,
        goal: null,
        giroMonths: [],
        giroTransactions: [],
      }
    },
    kanban: {
      columns: ["In Plannung", "Offen", "Warten", "Erledigt"],
      cards: [],
      tags: []
    }
  },
  getters: {
    getRandomUUID(){
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    getDevice(state){
      return state.smarthaus.devices
    },
    getSmarthaus(state){
      return state.smarthaus
    },
    getKanban(state){
      return state.kanban
    }
  },
  mutations: {
    // GENERAL
    // beim seiten neu laden
    reset(state){
      state.smarthaus.rooms = []
      state.smarthaus.routines = []
      state.smarthaus.devices = []
      state.smarthaus.finanzen = {
        shares: [],
        sales: [],
        dividends: [],
        summary: null,
        goal: null,
        giroMonths: [],
        giroTransactions: [],
      }

      state.kanban.tags = []
      state.kanban.cards = []
    },
    update_general_localNetwork(state, value){
      state.general.localNetwork = value
    },
    updateEdit(state, value){
      state.general.edit = value
    },

    // SMARTHAUS
    updateRooms(state, payload){
      state.smarthaus.rooms = payload
    },
    updateRoutines(state, payload){
      state.smarthaus.routines = payload
    },
    updateDevice(state, payload){
      state.smarthaus.devices[payload.id] = payload
    },
    // KANBAN
    updateTags(state, payload){
      state.kanban.tags = payload
    },
    updateCards(state, payload){
      state.kanban.cards = payload
    },
  },
  actions: {
    update(state, payload) {
      console.log(payload.context)
      // Base-URL: per .env(.local) via VUE_APP_BACKEND_URL überschreibbar,
      // sonst standardmäßig der nginx-Proxy `/api` auf demselben Host (analog
      // zu src/services/vacuum.js). nginx schränkt /api/ aufs Heimnetz ein, von
      // außen kommt 403 — vermeidet Mixed-Content-Probleme bei HTTPS-Auslieferung.
      // Im Dev-Server wird /api per vue.config.js auf https://reckhaus.it geleitet.
      // Für lokales Backend: VUE_APP_BACKEND_URL=http://localhost:8000 in .env.local setzen.
      let baseUrl = process.env.VUE_APP_BACKEND_URL || "/api";
      let query = baseUrl + payload.context;
      // Kein Auth-Header: das Backend prüft keinen Token, der Zugriffsschutz
      // liegt bei nginx (/api/ nur aus dem Heimnetz).
      fetch(query, {
        method: 'payload' in payload ? "POST" : "GET",
        body: JSON.stringify(payload.payload),
      })
          .then((response) => {
            if (response.status == 200) {
              return response.json();
            } else {
              console.log("StatusCode" + response.status)
              throw new Error(response.status);
            }
          })
          .then((data) => {
            //console.log(data)
            if("rooms" in data){
              this.state.smarthaus.rooms = data.rooms
            }
            if("devices" in data){
              this.state.smarthaus.devices = data.devices
            }
            if("routines" in data){
              this.state.smarthaus.routines = data.routines
            }
            if("shares" in data){
              this.state.smarthaus.finanzen.shares = data.shares
            }
            if("sales" in data){
              this.state.smarthaus.finanzen.sales = data.sales
            }
            if("dividends" in data){
              this.state.smarthaus.finanzen.dividends = data.dividends
            }
            if("summary" in data){
              this.state.smarthaus.finanzen.summary = data.summary
            }
            // /portfolio/goal liefert ein flaches Objekt ohne Wrapper-Key,
            // daher über den Context-Pfad zuordnen (404 = kein Ziel → bleibt null).
            if(payload.context && payload.context.split('?')[0] === '/portfolio/goal'){
              this.state.smarthaus.finanzen.goal = data
            }
            if("months" in data){
              this.state.smarthaus.finanzen.giroMonths = data.months
            }
            if("giro_transactions" in data){
              this.state.smarthaus.finanzen.giroTransactions = data.giro_transactions
            }
            if("device" in data){
              let index = this.state.smarthaus.data.findIndex(d => d.id === data.device.id)
              if(index == -1){
                this.state.smarthaus.data.push(data.device)
              }
              else{
                for(let key in data.device){
                  this.state.smarthaus.data[index][key] = data.device[key]
                }
              }
            }
            else if(payload.context == "/get/kanban"){
              this.state.kanban.cards = Object.values(data.value.cards)
              this.state.kanban.tags = Object.values(data.value.tags)
            }
          })
          .catch((errorCode) => {
            console.error("[store/update] " + payload.context + ": " + errorCode)
            if ((errorCode + "").indexOf("NetworkError") != -1) {
              //this.dispatch("addInfoPopup",  {"status": "error", "message": "Server nicht erreichbar. Bitte Seite neu laden!"})
            }
          });
    }
  },
  modules: {
  },
})
